/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Lot_Size_Updated_ByInputs */

const vi_lot_size_updated_by = /** @type {(inputs: Lot_Size_Updated_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cập nhật bởi ${i?.name}`)
};

/**

* @param {Lot_Size_Updated_ByInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_size_updated_by = /** @type {((inputs: Lot_Size_Updated_ByInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Size_Updated_ByInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_size_updated_by(inputs)
});